exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-teeth[data-v-0cc6531a]{margin-top:7px}.modal-header[data-v-0cc6531a]{padding-bottom:0!important}.modal-body[data-v-0cc6531a]{padding-top:0!important}.customer-name[data-v-0cc6531a]{margin-bottom:16px;font-size:16px;line-height:1.25;color:var(--theme-text-color)}.status-check[data-v-0cc6531a]{flex:0 0 120px}", ""]);

// exports
